import DOService from "@/services/do.service";

export default {
    name: 'ClientCommon',
    data() {
      return {
          selectedClient: null,
          defaultOptionClient: [
              { value: null, text: 'Semua Client' },
          ],
          optionClient: this.defaultOptionClient,
          selectedArea: null,
          optionArea: [
              { value: null, text: 'Pilih Spesifik Area' },
          ],

      }
    },
    methods: {
        getClients() {
            this.optionClient = this.defaultOptionClient
            DOService.listClient().then(
                response => {
                    let cs = response.data;
                    for(let iii = 0; iii < cs.length; iii++) {
                        let b = cs[iii]
                        this.optionClient.push( { value: b.client_id, text: b.client_id } )
                    }
                },
                error => {
                    if (error.response.status === 401) {
                        this.$store.dispatch('auth/logout');
                        this.$router.push('/login')
                    }
                    this.content =
                        (error.response && error.response.data) ||
                        error.message ||
                        error.toString();
                }
            );
        },
        getArea() {
            this.optionClient = this.defaultOptionClient
            DOService.listCity().then(
                response => {
                    let cs = response.data;
                    for(let iii = 0; iii < cs.length; iii++) {
                        let b = cs[iii]
                        this.optionArea.push( { value: b.city_name, text: b.city_name } )
                    }
                },
                error => {
                    if (error.response.status === 401) {
                        this.$store.dispatch('auth/logout');
                        this.$router.push('/login')
                    }
                    this.content =
                        (error.response && error.response.data) ||
                        error.message ||
                        error.toString();
                }
            );
        },
    },
}